import React from 'react';
import HospitalCard from '../cards/HospitalCard';

const HospitalList = ({ 
  hospitals = [], 
  loading = false, 
  viewMode = 'grid',
  showDistance = false,
  onHospitalClick,
  onCallHospital,
  className = ''
}) => {
  
  if (loading) {
    return (
      <div className={`space-y-4 ${className}`}>
        {Array.from({ length: 6 }, (_, index) => (
          <HospitalSkeleton key={index} viewMode={viewMode} />
        ))}
      </div>
    );
  }

  if (!hospitals || hospitals.length === 0) {
    return (
      <div className={`text-center py-12 ${className}`}>
        <div className="w-24 h-24 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
          <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
        </div>
        <h3 className="text-xl font-semibold text-gray-900 mb-2">No hospitals found</h3>
        <p className="text-gray-600 mb-4">
          Try adjusting your search criteria or filters to find hospitals in your area.
        </p>
        <p className="text-sm text-gray-500">
          You can search by name, location, or medical services.
        </p>
      </div>
    );
  }

  const containerClass = viewMode === 'grid' 
    ? 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6' 
    : 'space-y-4';

  return (
    <div className={`${containerClass} ${className}`}>
      {hospitals.map((hospital) => (
        <HospitalCard
          key={hospital._id}
          hospital={hospital}
          viewMode={viewMode}
          showDistance={showDistance}
          onViewDetails={onHospitalClick}
          onCall={onCallHospital}
          className="h-full"
        />
      ))}
    </div>
  );
};

// Skeleton loading component
const HospitalSkeleton = ({ viewMode }) => {
  if (viewMode === 'grid') {
    return (
      <div className="bg-white rounded-xl shadow-lg overflow-hidden animate-pulse">
        <div className="h-48 bg-gray-200"></div>
        <div className="p-4">
          <div className="h-6 bg-gray-200 rounded mb-2"></div>
          <div className="h-4 bg-gray-200 rounded w-3/4 mb-3"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2 mb-3"></div>
          <div className="flex gap-2 mb-3">
            <div className="h-6 bg-gray-200 rounded w-16"></div>
            <div className="h-6 bg-gray-200 rounded w-20"></div>
            <div className="h-6 bg-gray-200 rounded w-14"></div>
          </div>
          <div className="flex justify-between items-center pt-3 border-t border-gray-200">
            <div className="h-4 bg-gray-200 rounded w-20"></div>
            <div className="h-8 bg-gray-200 rounded w-24"></div>
          </div>
        </div>
      </div>
    );
  }

  // List view skeleton
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden animate-pulse">
      <div className="flex">
        <div className="w-48 h-32 bg-gray-200 flex-shrink-0"></div>
        <div className="flex-1 p-4">
          <div className="h-6 bg-gray-200 rounded w-3/4 mb-2"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2 mb-3"></div>
          <div className="h-4 bg-gray-200 rounded w-2/3 mb-4"></div>
          <div className="flex justify-between items-center">
            <div className="flex gap-4">
              <div className="h-4 bg-gray-200 rounded w-16"></div>
              <div className="h-4 bg-gray-200 rounded w-20"></div>
            </div>
            <div className="flex gap-2">
              <div className="h-8 bg-gray-200 rounded w-16"></div>
              <div className="h-8 bg-gray-200 rounded w-24"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HospitalList;